import { render, staticRenderFns } from "./RiskConferenceSafetyCreate.vue?vue&type=template&id=11a52de6&scoped=true&"
import script from "./RiskConferenceSafetyCreate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceSafetyCreate.vue?vue&type=script&lang=js&"
import style1 from "./RiskConferenceSafetyCreate.vue?vue&type=style&index=1&id=11a52de6&lang=scss&scoped=true&"
import style2 from "./RiskConferenceSafetyCreate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a52de6",
  null
  
)

export default component.exports